import 'stylesheets/flat_2016/custom/3/index.scss';
import 'javascripts/flat_2016/index';

import Utils from "../../../libs/Utils";
import isMobile from "libs/Utils/isMobile";

Utils.textfit(document.getElementsByClassName("type"), {
  alignHoriz: true,
  widthOnly: true,
  maxFontSize: 14
});

const couponAmountMaxFontSize = isMobile.mobile() ? 24 : 36;

Utils.textfit(document.getElementsByClassName("amount"), {
  alignHoriz: true,
  widthOnly: true,
  maxFontSize: couponAmountMaxFontSize
});
